
import { useTranslation, Trans } from "react-i18next";

import coin from '../../img/Home/coin.png'

import { Fade } from 'react-awesome-reveal';

function SimpleSteps() {

  const { t } = useTranslation();

  return (
    <div className="relative pt-[80px] xl:pt-[160px] overflow-hidden">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
            <p className="zen-dots leading-[1.2] text-[24px] xl:text-[36px] text-[#1E1C21] xl:max-w-[517px]">
                <Trans>{t("main.49")}</Trans>
            </p>
            <div className="mt-[40px] xl:mt-[60px] flex flex-col xl:flex-row">
                <div className="flex flex-col">
                    <div className="p-[10px] pb-[30px] xl:pb-[40px] xl:p-[20px] bg-white border border-[#B8B6B8]">
                        <div className="flex gap-[20px] xl:gap-[35px]">
                            <div className="w-[54px] h-[54px] xl:w-[69px] xl:h-[69px] flex-shrink-0 bg-[#1E1C21] flex items-center justify-center">
                                <p className="zen-dots text-[#FFFFFF80] text-[20px] xl:text-[24px]">01</p>
                            </div>
                            <div className="flex gap-[8px]">
                                <div className="w-[2px] h-[18px] bg-[#1E1C21] flex-shrink-0 mt-[2px] xl:mt-[6px]"></div>
                                <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21] xl:max-w-[335px]">{t('main.50')}</p>
                            </div> 
                        </div>
                        <p className="text-[#000000B2] ibm-plex text-[14px] xl:w-[540px] xl:ml-[115px] mt-[20px] xl:mt-0">{t('main.51')}</p>
                    </div>
                    <div className="p-[10px] pb-[30px] xl:pb-[40px] xl:p-[20px] bg-white border border-[#B8B6B8] mt-[6px] xl:mt-0">
                        <div className="flex gap-[20px] xl:gap-[35px]">
                            <div className="w-[54px] h-[54px] xl:w-[69px] xl:h-[69px] flex-shrink-0 bg-[#1E1C21] flex items-center justify-center">
                                <p className="zen-dots text-[#FFFFFF80] text-[20px] xl:text-[24px]">02</p>
                            </div>
                            <div className="flex gap-[8px]">
                                <div className="w-[2px] h-[18px] bg-[#1E1C21] flex-shrink-0 mt-[2px] xl:mt-[6px]"></div>
                                <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21] xl:max-w-[335px]">{t('main.52')}</p>
                            </div> 
                        </div>
                        <p className="text-[#000000B2] ibm-plex text-[14px] xl:w-[540px] xl:ml-[115px] mt-[20px] xl:mt-0">{t('main.53')}</p>
                    </div>
                </div>
                <div className="bg-[#1E1C21] w-full relative overflow-hidden p-[10px] xl:p-[20px] pb-[200px] xl:pb-0 mt-[6px] xl:mt-0">  
                    <div className="flex gap-[20px] xl:gap-[35px]">
                        <div className="w-[54px] h-[54px] xl:w-[69px] xl:h-[69px] flex-shrink-0 bg-[#FFFFFF] flex items-center justify-center">
                            <p className="zen-dots text-[#1E1C2180] text-[20px] xl:text-[24px]">03</p>
                        </div>
                        <div className="flex gap-[8px]">
                            <div className="w-[2px] h-[18px] bg-[#FFFFFF] flex-shrink-0 mt-[2px] xl:mt-[6px]"></div>
                            <p className="zen-dots text-[16px] xl:text-[20px] text-[#FFFFFF] xl:max-w-[335px]">{t('main.54')}</p>
                        </div> 
                    </div>
                    <p className="text-[#FFFFFFB2] ibm-plex text-[14px] xl:w-[350px] xl:ml-[115px] mt-[20px] xl:mt-0 z-20 relative">{t('main.55')}</p>
                    <Fade><img src={coin} className="absolute right-0 bottom-0" alt="" /></Fade>
                </div>
            </div>
        </div>
    </div>
  );
}

export default SimpleSteps;
